import { inject, Injectable } from '@angular/core';
import { FiBackendService } from '../../../fi-backend/fi-backend.service';
import { LoadingService } from '../../../fi-loading/loading.service';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import {
    IChecklist2ScheduleParameter,
    IChecklist2UnitWithPeriodModel,
    IChecklistSchedule,
    IChecklistScheduleForList,
} from '@fi-shared/checklist/checklist-v2';
import { FiContentLanguageSharedService } from '@fi-shared/fi-content-language-shared/fi-content-language-shared.service';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

@Injectable()
export class FiChecklist2ScheduleService {
    private fiBackend = inject(FiBackendService);
    private fiLoading = inject(LoadingService);
    private fiContentLanguageSharedService = inject(FiContentLanguageSharedService);

    getChecklistSchedulesListData(parameter: IChecklist2ScheduleParameter): Promise<IItemsListDataFetchResult<IChecklistScheduleForList>> {
        const url = 'Checklist/Checklist2Schedule/GetChecklistSchedulesListData';
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<IChecklistScheduleForList>>(url, parameter);
    }

    getChecklistSchedule(scheduleId: number, auditMode: boolean): Promise<IChecklistSchedule> {
        const url = `Checklist/Checklist2Schedule/GetChecklistSchedule/${scheduleId}?auditMode=${!!auditMode}`;

        return new Promise<IChecklistSchedule>((resolve, reject) => {
            this.fiLoading.trackPromise(this.fiBackend.fetchData<IChecklistSchedule>(url)).then((data) => {
                this.fiContentLanguageSharedService.initializeContentLanguagesArray(data.Names, data.Names);
                resolve(data);
            }, reject);
        });
    }

    getChecklistSchedulesByChecklistId(checklistId: number, auditMode: boolean): Promise<INameIdObj[]> {
        const url = `Checklist/Checklist2Schedule/GetChecklistSchedulesByChecklistId/${checklistId}?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchData<INameIdObj[]>(url));
    }

    saveChecklistSchedule(checklistSchedule: IChecklistSchedule, auditMode: boolean): Promise<number> {
        const url = `Checklist/Checklist2Schedule/SaveChecklistSchedule?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<number>(url, checklistSchedule));
    }

    deleteChecklistSchedules(idsToDelete: number[], auditMode: boolean): Promise<void> {
        const url = `Checklist/Checklist2Schedule/DeleteChecklistSchedules?auditMode=${!!auditMode}`;
        return this.fiLoading.trackPromise(this.fiBackend.fetchDataPost<void>(url, idsToDelete));
    }

    getPeriodsByScheduleId(scheduleId: number, auditMode: boolean): Promise<IChecklist2UnitWithPeriodModel[]> {
        const url = `Checklist/Checklist2Schedule/GetPeriodsByScheduleId/${scheduleId}?auditMode=${!!auditMode}`;
        return this.fiBackend.fetchData<IChecklist2UnitWithPeriodModel[]>(url);
    }

    createPeriod(scheduleId: number, businessUnitId: number): Promise<IChecklist2UnitWithPeriodModel> {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<IChecklist2UnitWithPeriodModel>(
                `Checklist/Checklist2Schedule/CreatePeriod/${scheduleId}/${businessUnitId}`,
            ),
        );
    }
}
